import Dexie from 'dexie';

// Initialize the Dexie database
const db = new Dexie('SecureAppDB');
db.version(1).stores({
  auth: 'key, value', // Store authentication data
  operator: 'key, value', // Store operator ID
});

export default db;
